import { EventEmitter } from '../lib/classes';
export var emitter = new EventEmitter();
export var on = function (name, fn) { return emitter.on(name, fn); };
export var emit = function (name, data) { return emitter.emit(name, data); };
var EVENTS;
(function (EVENTS) {
    EVENTS["lang"] = "lang";
    EVENTS["coins"] = "coins";
    EVENTS["balance"] = "balance";
    EVENTS["balanceError"] = "balance-err";
})(EVENTS || (EVENTS = {}));
export var emitCoinsEvent = function (coins) { return emitter.emit(EVENTS.coins, { coins: coins }); };
export var onCoinsEvent = function (handler) { return emitter.on(EVENTS.coins, handler); };
import * as Fn from './fn';
export { Fn };
import * as init from './init';
export { init };
import * as settings from './settings/settings';
export { settings };
import * as sounds from './sounds';
export { sounds };
import * as stat from './stat';
export { stat };
import { appStorage as storage } from './storage';
export { storage };
import * as themes from './themes';
export { themes };
import * as features from './const/features';
export { features };
import * as ab from './ab';
export { ab };
